// extracted by mini-css-extract-plugin
export var promotionLink = "_tn-0";